module.exports = __webpack_public_path__ + "static/media/smartphone-dark.bf1fcd4b.svg";